import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import EmailTemplateListFilter from './EmailTemplateListFilter';
import EmailTemplateListService from '../services/EmailTemplateListService';

class EmailTemplateListFilterContainer extends React.Component {
  static propTypes = {
    initialFilters: PropTypes.object,
  };

  static defaultProps = {
    initialFilters: null,
  };

  componentDidMount() {
    EmailTemplateListService.init(this.props.initialFilters);
  }

  render() {
    return (
      <EmailTemplateListFilter
        values={EmailTemplateListService.form.getValues()}
        onChange={EmailTemplateListService.form.setValue}
        fetching={EmailTemplateListService.fetch.fetching}
        onSearch={EmailTemplateListService.handleLoad}
      />
    );
  }
}

export default observer(EmailTemplateListFilterContainer);
